import { render, staticRenderFns } from "./OProminents.vue?vue&type=template&id=977623ea&"
import script from "./OProminents.vue?vue&type=script&lang=js&"
export * from "./OProminents.vue?vue&type=script&lang=js&"
import style0 from "./OProminents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports